import { Button } from 'component-library';
import { useTranslation } from 'react-i18next';

import { CsvReportType } from '@/api/rest/resources/types/reports';
import { useCsvExportWithPolling } from '@/pages/shared/hooks/useReports';

type CsvExportButtonProps = {
  reportType: CsvReportType;
  reportName?: string;
  className?: string;
};

export const CsvExportButton = ({ reportType, reportName, className }: CsvExportButtonProps) => {
  const { t } = useTranslation();
  const fallbackReportName = t(`reports.reportTypes.${reportType}`);
  const { triggerExport, isLoading } = useCsvExportWithPolling(reportName ?? fallbackReportName);

  return (
    <Button className={className} onClick={() => triggerExport(reportType)} loading={isLoading}>
      {t('reports.dataExport.exportButton')}
    </Button>
  );
};
